import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Hidden from '@material-ui/core/Hidden'
import * as Msal from "msal";
import config from 'config'
import { userActions } from '../../_actions';
const styles = theme => ({
  paper: {
    [theme.breakpoints.down('sm')]: {
      left: '20px'
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '5% 40px 5% 40px',
    background: 'rgba(0, 0, 0, 0.6)',
    width: '300px',
    position: 'absolute',
    left: '25%'
  },
  submit: {
    marginTop: theme.spacing.unit * 8,
    borderRadius: '50px',
    border: '2px solid #f48fb1',
    padding: '10px 50px',
    color: '#f48fb1'
  },
  img: {
    top: '30%',
    position: 'absolute',
    left: '60%',
    height: '120px',
    paddingRight: '30px'
  },
  kanban: {
    top: '48%',
    position: 'absolute',
    left: '60%',
    height: '120px',
    paddingRight: '30px',
    fontSize: 'x-large',
    color: 'white'
  }
})

// Instantiate MSAL object
const myMSALObj = new Msal.UserAgentApplication(
  {
    auth: {
      clientId: config.clientId,
      authority: config.authorityUrl,
      postLogoutRedirectUri: config.loginUrl
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    }
  }
);
myMSALObj.handleRedirectCallback((error, response) => {
  // handle redirect response or error
  console.log(error, response)
});

const AuthContext = React.createContext();
class LoginFormComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  // Using MSAL loginPopup method
  login = () => {

    var loginRequest = {
      scopes: ["user.read"] // optional Array<string>
    };

    myMSALObj.loginPopup(loginRequest)
      .then(response => {
        if (myMSALObj.getAccount()) {
          myMSALObj.acquireTokenSilent(loginRequest)
            .then(response => {
              // get access token from response            
              this.showHomePage(response.accessToken)
            })
            .catch(err => {
              // could also check if err instance of InteractionRequiredAuthError if you can import the class.
              if (err.name === "InteractionRequiredAuthError") {
                return myMSALObj.acquireTokenPopup(loginRequest)
                  .then(response => {
                    // get access token from response
                    this.showHomePage(response.accessToken)
                  })
                  .catch(err => {
                    // handle error
                  });
              }else{
                //try redirect
                return myMSALObj.handleRedirectCallback(this.authRedirectCallBack);
              }
            });
        } else {
          // user is not logged in, you will need to log them in to acquire a token
        }
      })
      .catch(err => {
        // handle error
      });
  };

  showHomePage = (accessToken) => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(`${config.loginUrl}/?AuthorizationToken=${accessToken}`)
  }
  //20220502 update
  authRedirectCallBack = (error, response) => {
    if (error) {
        // 
    } else {
      if (response.tokenType === "access_token") {
        this.showHomePage(response.accessToken)
      }
    }
  }

  logout = () => {
    userActions.logout()
  };

  handleSubmitClick = () => {
    this.login()
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  render() {
    const { classes } = this.props
    return (
      <div>
        <Paper className={classes.paper}>
          <Typography
            component="h1"
            style={{
              color: '#afb1be',
              fontSize: '24px',
              paddingBottom: '35px'
            }}>
            CloudRiches x Hunter Game
          </Typography>
          <Button
            type="submit"
            className={classes.submit}
            onClick={this.handleSubmitClick.bind(this)}>
            Sign in
          </Button>
        </Paper>
        <Hidden smDown>
          <img src={require('../../images/cloudRiches_logo_white.png')} className={classes.img} alt="cloudRiches_logo_white" />
          <div className={classes.kanban}>Redefine IT with Cloud</div>
        </Hidden>
      </div>
    )
  }
}

LoginFormComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(LoginFormComponent)



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginFormComponent.js